import { Inject, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { APP_USES_LOGIN } from 'src/environments/app-uses-login';
import { AcceptTermsComponent } from './components/accept-terms/accept-terms.component';
import { LandingComponent } from '../landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';

import { TidLogoutComponent } from './components/tid-logout/tid-logout.component';
import { TidRedirectComponent } from './components/tid-redirect/tid-redirect.component';
import { TidAuthGuard } from './guards/tid-auth.guard';
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'terms', component: AcceptTermsComponent },
  { path: 'signup', component: SignUpComponent },
  { path: 'landing', component: LandingComponent },

  {
    path: 'tid',

    children: [
      {
        path: 'redirect',
        component: TidRedirectComponent,
        canActivate: [TidAuthGuard],
      },
      {
        path: 'logout',
        component: TidLogoutComponent,
      },
      { path: '**', redirectTo: '/tid/redirect' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AuthRoutingModule {
  constructor(router: Router, @Inject(APP_USES_LOGIN) appUsesLogin: boolean) {
    if (appUsesLogin) {
      return;
    }

    const authRouteLookup = new Set(routes.map((route) => route.path));
    router.resetConfig(
      router.config.filter((route) => !authRouteLookup.has(route.path))
    );
  }
}
